"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Customer = _interopRequireDefault(require("./Customer"));
var _CustomerContact = _interopRequireDefault(require("./CustomerContact"));
var _Role = _interopRequireDefault(require("./Role"));
var _Subscription = _interopRequireDefault(require("./Subscription"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The LoggedInUser model module.
 * @module model/LoggedInUser
 * @version 1.1.3-alpha.1
 */
class LoggedInUser {
  /**
   * Constructs a new <code>LoggedInUser</code>.
   * @alias module:model/LoggedInUser
   */
  constructor() {
    LoggedInUser.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>LoggedInUser</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/LoggedInUser} obj Optional instance to populate.
   * @return {module:model/LoggedInUser} The populated <code>LoggedInUser</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new LoggedInUser();
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('email')) {
        obj['email'] = _ApiClient.default.convertToType(data['email'], 'String');
      }
      if (data.hasOwnProperty('role')) {
        obj['role'] = _Role.default.constructFromObject(data['role']);
      }
      if (data.hasOwnProperty('created_at')) {
        obj['created_at'] = _ApiClient.default.convertToType(data['created_at'], 'String');
      }
      if (data.hasOwnProperty('customer')) {
        obj['customer'] = _Customer.default.constructFromObject(data['customer']);
      }
      if (data.hasOwnProperty('contact')) {
        obj['contact'] = _CustomerContact.default.constructFromObject(data['contact']);
      }
      if (data.hasOwnProperty('subscription')) {
        obj['subscription'] = _Subscription.default.constructFromObject(data['subscription']);
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>LoggedInUser</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LoggedInUser</code>.
   */
  static validateJSON(data) {
    // ensure the json data is a string
    if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
      throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
    }
    // ensure the json data is a string
    if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
      throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
    }
    // validate the optional field `role`
    if (data['role']) {
      // data not null
      _Role.default.validateJSON(data['role']);
    }
    // validate the optional field `customer`
    if (data['customer']) {
      // data not null
      _Customer.default.validateJSON(data['customer']);
    }
    // validate the optional field `contact`
    if (data['contact']) {
      // data not null
      _CustomerContact.default.validateJSON(data['contact']);
    }
    // validate the optional field `subscription`
    if (data['subscription']) {
      // data not null
      _Subscription.default.validateJSON(data['subscription']);
    }
    return true;
  }
}

/**
 * @member {String} id
 */
LoggedInUser.prototype['id'] = undefined;

/**
 * @member {String} email
 */
LoggedInUser.prototype['email'] = undefined;

/**
 * @member {module:model/Role} role
 */
LoggedInUser.prototype['role'] = undefined;

/**
 * @member {String} created_at
 */
LoggedInUser.prototype['created_at'] = undefined;

/**
 * @member {module:model/Customer} customer
 */
LoggedInUser.prototype['customer'] = undefined;

/**
 * @member {module:model/CustomerContact} contact
 */
LoggedInUser.prototype['contact'] = undefined;

/**
 * @member {module:model/Subscription} subscription
 */
LoggedInUser.prototype['subscription'] = undefined;
var _default = exports.default = LoggedInUser;